import { Injectable } from "@angular/core";
import { AbLoad } from "app/abstract/full-pages/load/load.abstract";
import { exibirImagemLoading } from "assets/js/barload";

Injectable()
@Injectable({ providedIn: 'root' })
export class LoadService extends AbLoad {

  public habilitar(mensagem?: string) {
    this.alterarTextoLoading(mensagem);
    exibirImagemLoading(true, true);
  }

  public desabilitar() {
    exibirImagemLoading(false, false);
  }

  private alterarTextoLoading(mensagem: string) {
    const loadText = document.querySelector('.load-text');
    if (loadText) {
      loadText.textContent = mensagem || 'Carregando a página';
    }
  }
}
